import { Area } from './area';
import { City } from './city';
import { CountryCode } from './country';
import { FileObject } from './file-object';
import { Lookup } from './lookup';
import { OptionSetItem } from './option-set';

export interface SecurityCompany {
  id: number;
  name: string;
  cityId: number;
  city: City;
  areaId: number;
  area: Area;
  companyStartDate: string;
  financeYearId: number;
  financeYear: Lookup;
  timeZoneLookupId: number;
  timeZoneLookup: Lookup;
  companyScaleId: number;
  companyScale: Lookup;
  companyContactNumber: string;
  postalCode: number;
  website: string;
  socialMediaLink: string;
  socialMediaLink2: string;
  address: string;
  businessDescription: string;
  companyLogoId: number;
  companyLogo: FileObject;
  commercialRegisterId: number;
  commercialRegister: FileObject;
  accountHolderName: string;
  bankName: string;
  bankCode: string;
  taxNumber: string;
  accountName: string;
  bankBranch: string;
  iban: string;
  idProofId: number;
  idProof: FileObject;
  appUserId: string;
  appUser: AppUser;
  securitCompanyAvailableServices: SecuritCompanyAvailableService[];
  firstName: string;
  lastName: string;
  middleName: string;
  email: string;
  profileImageId: number;
  profileImage: FileObject;
  businessTypeId: number;
  businessType: Lookup;
  isApproved: boolean;
  isActive: boolean;
  isRejected: boolean;
  locationLat: string;
  locationLng: string;
  companyAvilableShifts: CompanyAvilableShift[];
  companyAvilableContractTypes: CompanyAvilableContractType[];
  securityCompanyBranch: Branch;
  overview: string;
  overviewEn: string;
  breakAutomaticClose: number;
  attendanceAutomaticClose: number;
  earlyLog: number;
  commercialRegisterNumber: number;
  latLogOut: number;
  licenseNumber: string;
  licenseEndDate: string;
  licenseImageId: number;
}

interface AppUser {
  id: string;
  firstName: string;
  lastName: string;
  countryId: number;
  country: CountryCode;
  nationality: string;
  userName: string;
  isActive: boolean;
  roles: string[];
  email: string;
}

export interface BusinessType {
  id: number;
  isDeleted?: boolean;
  name: string;
  nameEN: string;
  description?: string;
}

export interface CompanyAvilableContractType {
  id: string;
  contractTypeId: string;
  contractType: OptionSetItem;
}

export interface CompanyAvilableShift {
  id: string;
  shiftTypeId: number;
  shiftType: BusinessType;
}

export interface SecuritCompanyAvailableService {
  id: number;
  availableServicesId: number;
  availableServices: BusinessType;
}

// Generated by https://quicktype.io

export interface Branch {
  id: string;
  securityCompanyId: number;
  name: string;
  nameEn: string;
  overview: string;
  overviewEn: string;
  address: string;
  locationLat: string;
  locationLng: string;
  photoId: number;
  photo: null;
  stauts: boolean;
  isMainBranch: boolean;
}
